// removed by extract-text-webpack-plugin
module.exports = {"marginTop":"_3SVEZ"};


//////////////////
// WEBPACK FOOTER
// ../source/static/AboutUs.css
// module id = 534
// module chunks = 0 23